import { useState, useEffect } from "react";
import Modal from "react-modal";
import { IMaskInput } from "react-imask";
import "./style.css";

import Sidebar from "../../componente/sidebar/index.jsx";
import PageHeader from "../../componente/topbar/index.jsx";
import AutoComplete from "../../componente/cadastro/autocomplete/index.jsx";

import { useCrud } from "../../hooks/useCrud";
import { useAppContext } from "../../pages/context/AppContext.jsx";
import api from "../../services/api";

Modal.setAppElement("#root");

function Meta() {

    const { codusuario } = useAppContext();

    /* ==============================
       IMPORTAÇÃO DINÂMICA IMAGENS
    ============================== */

    const importarImagens = () => {

        const contexto = require.context(
            "../../assets/Categoria",
            false,
            /\.png$/
        );

        const imagens = {};

        contexto.keys().forEach((key) => {

            const nomeArquivo = key
                .replace("./", "")
                .replace(".png", "");

            const index = parseInt(nomeArquivo) - 1;

            imagens[index] = contexto(key);

        });

        return imagens;

    };

    const imagens = importarImagens();

    /* ============================== */

    const [sidebarAberto, setSidebarAberto] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalCategoriaOpen, setModalCategoriaOpen] = useState(false);

    const [editando, setEditando] = useState(null);

    const {
        dados: metas,
        listar,
        criar,
        editar
    } = useCrud({
        rotaLista: "v1/meta",
        rotaUm: "v1/metaum"
    });

    useEffect(() => {
        listar({ codusuario });
    }, []);

    /* ================= CATEGORIA ================= */

    const fetchCategorias = async (query) => {

        const response = await api.get("v1/busca/categoria", {
            params: {
                descricao: query,
                codusuario
            }
        });

        return response.data.map(c => ({
            id: c.id,
            label: c.label
        }));

    };

    /* ================= FORM META ================= */

    const initialForm = {
        descricao: "",
        ano: new Date().getFullYear(),
        meses: Array(12).fill("")
    };

    const [form, setForm] = useState(initialForm);
    const [categoriaSelecionada, setCategoriaSelecionada] = useState(null);

    const mesesLabel = [
        "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
        "Jul", "Ago", "Set", "Out", "Nov", "Dez"
    ];

    const formatar = (v) =>
        Number(v || 0).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL"
        });

    /* ================= FORM CATEGORIA ================= */

    const initialCategoriaForm = {
        descricao: "",
        indexcategoria: null
    };

    const [categoriaForm, setCategoriaForm] = useState(initialCategoriaForm);

    /* ================= ABRIR MODAL ================= */

    const abrirModal = (item = null) => {

        if (item) {

            setEditando(item.codmeta);

            setForm({
                descricao: item.descricao,
                ano: item.ano,
                meses: [
                    item.valjan,
                    item.valfev,
                    item.valmar,
                    item.valabr,
                    item.valmai,
                    item.valjun,
                    item.valjul,
                    item.valago,
                    item.valset,
                    item.valout,
                    item.valnov,
                    item.valdez
                ].map(v => String(v ?? ""))
            });

            setCategoriaSelecionada({
                id: item.codcategoria,
                label: item.descricao
            });

        } else {

            setEditando(null);
            setForm(initialForm);
            setCategoriaSelecionada(null);

        }

        setModalOpen(true);

    };

    /* ================= SALVAR META ================= */

    const salvar = async () => {

        const dt1 = new Date();

        const date1 =
            dt1.getFullYear() +
            "-" +
            (dt1.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt1.getDate().toString().padStart(2, "0");

        const time1 =
            dt1.getHours().toString().padStart(2, "0") +
            ":" +
            dt1.getMinutes().toString().padStart(2, "0");

        if (!categoriaSelecionada) return;

        const dados = {
            dtalteracao: `${date1}T${time1}`,
            codusuario,
            codcategoria: categoriaSelecionada.id,
            descricao: categoriaSelecionada.label,
            ano: form.ano,
            meses: form.meses
        };

        if (editando) {

            await editar({
                codmeta: editando,
                ...dados
            });

        } else {

            await criar(dados);

        }

        setModalOpen(false);

    };

    /* ================= SALVAR CATEGORIA ================= */

    const salvarCategoria = async () => {

        if (!categoriaForm.descricao || !categoriaForm.indexcategoria) return;

        const response = await api.post("v1/categoria", {
            codusuario,
            descricao: categoriaForm.descricao,
            indexcategoria: categoriaForm.indexcategoria
        });

        const nova = {
            id: response.data.codcategoria,
            label: categoriaForm.descricao
        };

        setCategoriaSelecionada(nova);

        setForm(prev => ({
            ...prev,
            descricao: nova.label
        }));

        setCategoriaForm(initialCategoriaForm);

        setModalCategoriaOpen(false);

    };

    return (
        <>
            <PageHeader
                titulo="Metas"
                subtitulo="Defina metas mensais por categoria"
                abrirMenu={() => setSidebarAberto(true)}

                botaoAdicionar
                textoAdicionar="Nova Meta"
                onAdicionar={() => abrirModal()}
            />

            <div className="meta-container">

                <Sidebar
                    aberto={sidebarAberto}
                    fechar={() => setSidebarAberto(false)}
                />

                <div className="meta-wrapper">

                    {/* ================= LISTAGEM ================= */}

                    <div className="meta-list">

                        {metas.map((m) => (

                            <div
                                key={m.codmeta}
                                className="meta-card1"
                                onClick={() => abrirModal(m)}
                            >

                                <div className="row">

                                    <div className="meta-top">
                                        <strong>{m.descricao}</strong>
                                        <span>Ano {m.ano}</span>
                                    </div>

                                </div>

                                <div className="row">

                                    <div className="meta-months-row">

                                        {[
                                            m.valjan,
                                            m.valfev,
                                            m.valmar,
                                            m.valabr,
                                            m.valmai,
                                            m.valjun,
                                            m.valjul,
                                            m.valago,
                                            m.valset,
                                            m.valout,
                                            m.valnov,
                                            m.valdez
                                        ].map((valor, i) => (

                                            <div key={i} className="month-mini">
                                                <small>{mesesLabel[i]}</small>
                                                <span>{formatar(valor)}</span>
                                            </div>

                                        ))}

                                    </div>

                                </div>

                            </div>

                        ))}

                    </div>

                    {/* ================= MODAL META ================= */}

                    <Modal
                        isOpen={modalOpen}
                        onRequestClose={() => setModalOpen(false)}
                        className="modal-content"
                        overlayClassName="modal-overlay"
                    >

                        <div className="modal-header">
                            <h3>{editando ? "Editar Meta" : "Nova Meta"}</h3>
                        </div>

                        <div className="modal-body">

                            <AutoComplete
                                fetchData={fetchCategorias}
                                initialValue={categoriaSelecionada}
                                onSelect={(item) => {

                                    setCategoriaSelecionada(item);

                                    setForm({
                                        ...form,
                                        descricao: item?.label || ""
                                    });

                                }}
                                onAdd={() => setModalCategoriaOpen(true)}
                                txtLabel="Categoria"
                            />

                            <input
                                type="number"
                                value={form.ano}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        ano: e.target.value
                                    })
                                }
                                placeholder="Ano"
                            />

                            <div className="modal-meses-grid">

                                {mesesLabel.map((mes, index) => (

                                    <div key={index}>

                                        <label>{mes}</label>

                                        <IMaskInput
                                            mask={Number}
                                            scale={2}
                                            thousandsSeparator="."
                                            radix=","
                                            padFractionalZeros={true}
                                            value={form.meses[index]}
                                            onAccept={(value) => {

                                                const novosMeses = [...form.meses];

                                                novosMeses[index] = value;

                                                setForm({
                                                    ...form,
                                                    meses: novosMeses
                                                });

                                            }}
                                        />

                                    </div>

                                ))}

                            </div>

                        </div>

                        <div className="modal-footer">

                            <button
                                className="btn-cancelar"
                                onClick={() => setModalOpen(false)}
                            >
                                Cancelar
                            </button>

                            <button
                                className="btn-salvar"
                                onClick={salvar}
                            >
                                Salvar
                            </button>

                        </div>

                    </Modal>

                    {/* ================= MODAL CATEGORIA ================= */}

                    <Modal
                        isOpen={modalCategoriaOpen}
                        onRequestClose={() => setModalCategoriaOpen(false)}
                        className="modal-content"
                        overlayClassName="modal-overlay"
                    >

                        <h3>Nova Categoria</h3>

                        <div className="modal-imagens">

                            {Object.keys(imagens).map((i) => (

                                <img
                                    key={i}
                                    src={imagens[i]}
                                    alt=""
                                    className={
                                        categoriaForm.indexcategoria === parseInt(i)
                                            ? "ativo"
                                            : ""
                                    }
                                    onClick={() =>
                                        setCategoriaForm({
                                            ...categoriaForm,
                                            indexcategoria: parseInt(i)
                                        })
                                    }
                                />

                            ))}

                        </div>

                        <input
                            type="text"
                            placeholder="Descrição da categoria"
                            value={categoriaForm.descricao}
                            onChange={(e) =>
                                setCategoriaForm({
                                    ...categoriaForm,
                                    descricao: e.target.value
                                })
                            }
                        />

                        <div className="modal-actions">

                            <button
                                className="btn-cancelar"
                                onClick={() => setModalCategoriaOpen(false)}
                            >
                                Cancelar
                            </button>

                            <button
                                className="btn-salvar"
                                onClick={salvarCategoria}
                            >
                                Salvar
                            </button>

                        </div>

                    </Modal>

                </div>

            </div>
        </>
    );
}

export default Meta;